import { render } from "./CreateScopeView.vue?vue&type=template&id=6e45a9f1"
import script from "./CreateScopeView.vue?vue&type=script&lang=js"
export * from "./CreateScopeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__